import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

export const StyledTable = styled.table<Props>`
  width: 100%;
  border-radius: 1rem;
  border: solid 1px ${(props: Props) => props.theme.palette.neutral._900};
  background: ${(props: Props) => props.theme.palette.neutral.white};

  thead {
    font-size: ${(props: Props) => props.theme.font.size._14};
    font-weight: ${(props: Props) => props.theme.font.weight.bold};
  }

  tbody {
    tr {
      td {
        border-top: solid 1px ${(props: Props) => props.theme.palette.neutral._900};
      }
    }
  }

  tr {
    display: grid;
    grid-template-columns: 1fr 2fr 7rem;
  }

  td {
    padding: 1rem;
  }
`;
